module.exports = __webpack_public_path__ + "img/empty_asset.bf75a153.png";